var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKuzelAddDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1000px",
    height: "1000px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.189
    },
    fill: "#fdfdfd",
    d: "M 530.5,47.5 C 500.613,41.5063 471.613,44.3396 443.5,56C 432.404,61.6231 423.238,69.4565 416,79.5C 413.993,84.0192 412.493,88.6859 411.5,93.5C 403.28,128.049 394.613,162.382 385.5,196.5C 386.185,189.426 387.351,182.426 389,175.5C 397.433,146.103 404.766,116.436 411,86.5C 417.808,70.3589 429.308,58.8589 445.5,52C 471.856,41.9308 498.856,39.5974 526.5,45C 528.32,45.2004 529.653,46.0337 530.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "#b9b4ad",
    d: "M 530.5,47.5 C 537.079,49.4824 543.746,51.4824 550.5,53.5C 551.492,53.3284 552.158,53.6618 552.5,54.5C 555.484,56.6588 558.817,58.3255 562.5,59.5C 563.167,59.8333 563.833,60.1667 564.5,60.5C 564.973,61.9063 565.973,62.573 567.5,62.5C 568.167,62.5 568.5,62.8333 568.5,63.5C 578.868,70.8937 585.201,80.8937 587.5,93.5C 585.099,110.111 576.432,122.611 561.5,131C 530.879,146.045 498.879,149.712 465.5,142C 446.268,137.975 430.434,128.475 418,113.5C 414.274,107.238 412.108,100.571 411.5,93.5C 412.493,88.6859 413.993,84.0192 416,79.5C 423.238,69.4565 432.404,61.6231 443.5,56C 471.613,44.3396 500.613,41.5063 530.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.116
    },
    fill: "#fbfafa",
    d: "M 530.5,47.5 C 537.941,47.3171 544.608,49.3171 550.5,53.5C 543.746,51.4824 537.079,49.4824 530.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.111
    },
    fill: "#fafafa",
    d: "M 552.5,54.5 C 556.684,54.5919 560.017,56.2586 562.5,59.5C 558.817,58.3255 555.484,56.6588 552.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.055
    },
    fill: "#fcfcfc",
    d: "M 564.5,60.5 C 566.027,60.427 567.027,61.0937 567.5,62.5C 565.973,62.573 564.973,61.9063 564.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e8b87",
    d: "M 489.5,65.5 C 508.148,63.6635 525.481,67.4968 541.5,77C 552.582,85.9238 554.415,96.4238 547,108.5C 534.912,119.119 520.745,124.619 504.5,125C 485.02,127.283 467.854,122.116 453,109.5C 444.501,97.3459 446.001,86.5125 457.5,77C 467.356,70.5567 478.022,66.7234 489.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.175
    },
    fill: "#fdfdfc",
    d: "M 568.5,63.5 C 578.824,68.7969 585.324,77.1302 588,88.5C 606.009,161.187 624.009,233.854 642,306.5C 645.543,316.794 648.876,327.128 652,337.5C 654.518,339.464 657.184,340.13 660,339.5C 660.75,340.126 661.584,340.626 662.5,341C 673.61,341.422 684.61,342.755 695.5,345C 704.455,346.572 713.121,348.739 721.5,351.5C 697.813,346.206 673.813,343.539 649.5,343.5C 647.611,334.274 645.278,325.274 642.5,316.5C 624.322,242.121 605.988,167.787 587.5,93.5C 585.201,80.8937 578.868,70.8937 568.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#a09d98",
    d: "M 411.5,93.5 C 412.108,100.571 414.274,107.238 418,113.5C 430.434,128.475 446.268,137.975 465.5,142C 498.879,149.712 530.879,146.045 561.5,131C 576.432,122.611 585.099,110.111 587.5,93.5C 605.988,167.787 624.322,242.121 642.5,316.5C 637.597,321.897 631.93,326.397 625.5,330C 569.947,358.584 511.28,367.584 449.5,357C 419.344,351.839 391.344,341.173 365.5,325C 362,322.666 359,319.832 356.5,316.5C 356.993,314.194 357.326,311.861 357.5,309.5C 362.276,292.06 366.61,274.393 370.5,256.5C 372.102,252.761 373.102,248.761 373.5,244.5C 376.102,236.76 378.102,228.76 379.5,220.5C 381.102,216.761 382.102,212.761 382.5,208.5C 384.102,204.761 385.102,200.761 385.5,196.5C 394.613,162.382 403.28,128.049 411.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.132
    },
    fill: "#fcfcfc",
    d: "M 385.5,196.5 C 385.102,200.761 384.102,204.761 382.5,208.5C 382.337,206.143 382.503,203.81 383,201.5C 383.099,199.347 383.933,197.681 385.5,196.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#fcfcfc",
    d: "M 382.5,208.5 C 382.102,212.761 381.102,216.761 379.5,220.5C 379.337,218.143 379.503,215.81 380,213.5C 380.099,211.347 380.933,209.681 382.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.157
    },
    fill: "#fdfdfd",
    d: "M 379.5,220.5 C 378.102,228.76 376.102,236.76 373.5,244.5C 373.337,242.143 373.503,239.81 374,237.5C 375.281,231.524 377.114,225.857 379.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.139
    },
    fill: "#fefefd",
    d: "M 373.5,244.5 C 373.102,248.761 372.102,252.761 370.5,256.5C 370.034,252.018 371.034,248.018 373.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.153
    },
    fill: "#fdfdfd",
    d: "M 370.5,256.5 C 366.61,274.393 362.276,292.06 357.5,309.5C 357.336,306.813 357.503,304.146 358,301.5C 361.718,286.284 365.885,271.284 370.5,256.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.997
    },
    fill: "#dfdfe1",
    d: "M 356.5,316.5 C 359,319.832 362,322.666 365.5,325C 391.344,341.173 419.344,351.839 449.5,357C 511.28,367.584 569.947,358.584 625.5,330C 631.93,326.397 637.597,321.897 642.5,316.5C 645.278,325.274 647.611,334.274 649.5,343.5C 543.274,346.52 460.108,391.52 400,478.5C 385.87,499.76 374.703,522.426 366.5,546.5C 345.253,536.376 326.253,523.043 309.5,506.5C 324.564,442.911 340.231,379.578 356.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#bab5ae",
    d: "M 649.5,343.5 C 673.813,343.539 697.813,346.206 721.5,351.5C 750.412,359.696 778.079,371.029 804.5,385.5C 811.796,390.487 819.13,395.487 826.5,400.5C 833.825,406.164 841.158,411.831 848.5,417.5C 856.785,426.452 865.452,435.119 874.5,443.5C 885.9,457.307 896.567,471.64 906.5,486.5C 907.338,486.842 907.672,487.508 907.5,488.5C 907.427,490.027 908.094,491.027 909.5,491.5C 916.437,505.041 923.104,518.707 929.5,532.5C 960.757,619.093 955.59,703.426 914,785.5C 865.139,870.97 791.973,922.137 694.5,939C 662.781,943.877 631.115,943.544 599.5,938C 586.801,935.158 574.134,932.324 561.5,929.5C 557.784,927.595 553.784,926.261 549.5,925.5C 539.726,921.288 529.893,916.954 520,912.5C 513.367,916.566 506.534,920.233 499.5,923.5C 354.5,840.167 209.5,756.833 64.5,673.5C 64.5,672.833 64.8333,672.5 65.5,672.5C 144.167,627.167 222.833,581.833 301.5,536.5C 291.493,576.862 281.326,617.196 271,657.5C 267.779,682.051 273.445,704.384 288,724.5C 314.726,755.77 347.893,776.436 387.5,786.5C 347.665,709.454 340.665,629.454 366.5,546.5C 374.703,522.426 385.87,499.76 400,478.5C 460.108,391.52 543.274,346.52 649.5,343.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.105
    },
    fill: "#f6f5f5",
    d: "M 721.5,351.5 C 744.811,356.438 767.144,364.271 788.5,375C 794.412,377.778 799.745,381.278 804.5,385.5C 778.079,371.029 750.412,359.696 721.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.097
    },
    fill: "#f9f8f8",
    d: "M 804.5,385.5 C 805.873,385.343 807.207,385.51 808.5,386C 813.558,390.057 818.892,393.724 824.5,397C 825.823,397.816 826.489,398.983 826.5,400.5C 819.13,395.487 811.796,390.487 804.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.105
    },
    fill: "#f8f7f7",
    d: "M 826.5,400.5 C 834.981,404.643 842.314,410.31 848.5,417.5C 841.158,411.831 833.825,406.164 826.5,400.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.095
    },
    fill: "#fafaf9",
    d: "M 848.5,417.5 C 858.188,425.188 866.854,433.854 874.5,443.5C 865.452,435.119 856.785,426.452 848.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 627.5,433.5 C 717.115,428.813 785.615,464.147 833,539.5C 860.423,589.468 867.09,642.134 853,697.5C 826.472,781.697 769.972,832.53 683.5,850C 592.275,860.401 521.442,827.568 471,751.5C 434.659,687.636 430.992,621.969 460,554.5C 495.204,485.645 551.037,445.312 627.5,433.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bab5ae",
    d: "M 636.5,450.5 C 701.337,448.179 755.171,471.179 798,519.5C 840.585,573.543 852.585,633.876 834,700.5C 805.886,777.278 751.386,821.778 670.5,834C 591.246,838.789 529.746,808.289 486,742.5C 455.402,688.476 450.402,632.142 471,573.5C 502.702,500.969 557.869,459.969 636.5,450.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.114
    },
    fill: "#f9f9f8",
    d: "M 874.5,443.5 C 882.882,451.384 890.382,460.05 897,469.5C 899.606,474.435 902.606,479.102 906,483.5C 906.483,484.448 906.649,485.448 906.5,486.5C 896.567,471.64 885.9,457.307 874.5,443.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.133
    },
    fill: "#f8f4f4",
    d: "M 907.5,488.5 C 908.906,488.973 909.573,489.973 909.5,491.5C 908.094,491.027 907.427,490.027 907.5,488.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#a09d98",
    d: "M 309.5,506.5 C 326.253,523.043 345.253,536.376 366.5,546.5C 340.665,629.454 347.665,709.454 387.5,786.5C 347.893,776.436 314.726,755.77 288,724.5C 273.445,704.384 267.779,682.051 271,657.5C 281.326,617.196 291.493,576.862 301.5,536.5C 303.878,526.314 306.545,516.314 309.5,506.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.122
    },
    fill: "#fafaf9",
    d: "M 909.5,491.5 C 911.47,493.647 913.303,495.98 915,498.5C 920.715,509.485 925.548,520.818 929.5,532.5C 923.104,518.707 916.437,505.041 909.5,491.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 658.5,535.5 C 658.5,568.5 658.5,601.5 658.5,634.5C 691.167,634.5 723.833,634.5 756.5,634.5C 760.955,635.29 763.289,637.956 763.5,642.5C 763.751,646.503 762.084,649.336 758.5,651C 725.502,651.5 692.502,651.667 659.5,651.5C 659.667,683.835 659.5,716.168 659,748.5C 654.852,757.692 649.185,758.692 642,751.5C 641.5,718.168 641.333,684.835 641.5,651.5C 608.498,651.667 575.498,651.5 542.5,651C 535.115,646.123 534.782,640.789 541.5,635C 542.448,634.517 543.448,634.351 544.5,634.5C 577.167,634.5 609.833,634.5 642.5,634.5C 642.5,601.167 642.5,567.833 642.5,534.5C 645.616,529.305 649.95,528.138 655.5,531C 657.141,532.129 658.141,533.629 658.5,535.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.156
    },
    fill: "#fcfbfb",
    d: "M 357.5,309.5 C 357.326,311.861 356.993,314.194 356.5,316.5C 340.231,379.578 324.564,442.911 309.5,506.5C 306.545,516.314 303.878,526.314 301.5,536.5C 222.833,581.833 144.167,627.167 65.5,672.5C 66.5918,669.937 68.2585,667.77 70.5,666C 143.844,624.329 217.177,582.662 290.5,541C 297.263,536.657 301.429,530.49 303,522.5C 318.684,455.868 335.018,389.202 352,322.5C 353.527,317.93 355.36,313.597 357.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2dfdd",
    d: "M 642.5,534.5 C 642.5,567.833 642.5,601.167 642.5,634.5C 609.833,634.5 577.167,634.5 544.5,634.5C 576.662,633.502 608.996,633.168 641.5,633.5C 641.168,600.329 641.502,567.329 642.5,534.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2dfdd",
    d: "M 658.5,535.5 C 659.498,567.996 659.832,600.662 659.5,633.5C 692.004,633.168 724.338,633.502 756.5,634.5C 723.833,634.5 691.167,634.5 658.5,634.5C 658.5,601.5 658.5,568.5 658.5,535.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.186
    },
    fill: "#fcfbfb",
    d: "M 929.5,532.5 C 931.267,536.033 933.1,539.7 935,543.5C 947.77,580.889 953.27,619.389 951.5,659C 946.72,733.651 919.053,797.818 868.5,851.5C 822.426,899.378 766.426,929.211 700.5,941C 675.619,944.406 650.619,945.406 625.5,944C 612.891,942.356 600.558,940.356 588.5,938C 579.14,935.917 570.14,933.084 561.5,929.5C 574.134,932.324 586.801,935.158 599.5,938C 631.115,943.544 662.781,943.877 694.5,939C 791.973,922.137 865.139,870.97 914,785.5C 955.59,703.426 960.757,619.093 929.5,532.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.155
    },
    fill: "#fefffe",
    d: "M 64.5,673.5 C 64.5,683.5 64.5,693.5 64.5,703.5C 63.5057,697.601 62.5057,691.601 61.5,685.5C 61.0856,681.021 62.0856,677.021 64.5,673.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#a09d98",
    d: "M 64.5,673.5 C 209.5,756.833 354.5,840.167 499.5,923.5C 499.5,933.5 499.5,943.5 499.5,953.5C 354.337,870.419 209.337,787.086 64.5,703.5C 64.5,693.5 64.5,683.5 64.5,673.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.181
    },
    fill: "#fbfbfb",
    d: "M 64.5,703.5 C 209.337,787.086 354.337,870.419 499.5,953.5C 516.405,944.595 533.072,935.262 549.5,925.5C 553.784,926.261 557.784,927.595 561.5,929.5C 554.476,927.764 547.809,928.931 541.5,933C 530.496,940.171 519.162,946.838 507.5,953C 503.259,954.457 498.926,954.791 494.5,954C 450.092,927.935 405.426,902.269 360.5,877C 310.657,847.242 260.323,818.242 209.5,790C 164.683,763.266 119.349,737.266 73.5,712C 71.1667,710.333 68.8333,708.667 66.5,707C 65.1772,706.184 64.5106,705.017 64.5,703.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#8e8b87",
    d: "M 549.5,925.5 C 533.072,935.262 516.405,944.595 499.5,953.5C 499.5,943.5 499.5,933.5 499.5,923.5C 506.534,920.233 513.367,916.566 520,912.5C 529.893,916.954 539.726,921.288 549.5,925.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuzelAddDisabled);
export default __webpack_public_path__ + "static/media/kuzelAddDisabled.fb79082b5a89c8042aebd7360bf2983d.svg";
export { ForwardRef as ReactComponent };